import { Menu, ArrowLeft } from 'lucide-react';
import { ReactNode } from 'react';

interface MobileHeaderProps {
    title: string | ReactNode;
    onMenuClick?: () => void;
    onBackClick?: () => void;
    showBack?: boolean;
}

export function MobileHeader({ title, onMenuClick, onBackClick, showBack }: MobileHeaderProps) {
    return (
        <header className="lg:hidden fixed top-0 left-0 right-0 z-[100] h-14 bg-background/95 backdrop-blur-md border-b border-border">
            <div className="flex items-center h-full px-4 gap-3">
                {/* Left: Back or Menu */}
                {showBack ? (
                    <button
                        onClick={onBackClick}
                        className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-muted transition-colors"
                    >
                        <ArrowLeft className="w-5 h-5" strokeWidth={1.5} />
                    </button>
                ) : (
                    <button
                        onClick={onMenuClick}
                        className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-muted transition-colors"
                    >
                        <Menu className="w-5 h-5" strokeWidth={1.5} />
                    </button>
                )}

                {/* Center: Title */}
                <div className="flex-1 min-w-0">
                    <h1 className="text-[16px] font-semibold truncate">{title}</h1>
                </div>
            </div>
        </header>
    );
}
